import { createFileRoute, Outlet } from '@tanstack/react-router';
import type { ReactElement } from 'react';

import { TeamProvider } from '~/features/team/team-context';
import { TeamPage } from '~/features/team/team-page';

/**
 * The Team page and what opens over it: the invite sheet (/business/invite).
 * One layout, so the table behind it stays mounted and shares its lists. A
 * person opens in the page's own right panel (?person=).
 */
function TeamLayout(): ReactElement {
  return (
    <TeamProvider>
      <TeamPage />
      <Outlet />
    </TeamProvider>
  );
}

export const Route = createFileRoute('/_app/business/_team')({ component: TeamLayout });
